module.exports = __webpack_public_path__ + "static/biancaWallpaper4-4b334a0f8447a8070c3cccdccd5d3385.jpg";